<template>
  <div class="main-wrapper">
    <div class="wrapper">
      <div class="left-collar-holder">
        <div class="left-collar">
          <div class="left-collar-inner">
            <div class="avatar-holder">
              <img :src="avatarUrl ? avatarUrl : defaultAvatar" alt="" />
              <div class="file-container">
                <label for="">{{ $t("admin.changeIMage") }} </label>
                <input
                  @change="changeAvatar()"
                  ref="avatar"
                  class="file"
                  :label="$t('authorization.selectImage')"
                  type="file"
                  accept="image/Jpeg"
                />
              </div>
            </div>
            <router-link
              :to="$staffI18nRoute({ name: 'AccountSettings' })"
              class="account-settings"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M23.5867 14.6172L21.3328 12.8937C21.3614 12.6279 21.386 12.3172 21.386 11.9885C21.386 11.6598 21.3624 11.3491 21.3328 11.0833L23.5887 9.35881C24.0076 9.0351 24.122 8.46059 23.8554 7.98204L21.5116 4.01647C21.2613 3.56888 20.7127 3.33907 20.1559 3.53989L17.4964 4.58396C16.9866 4.22428 16.4523 3.92056 15.8995 3.67777L15.495 0.919209C15.4285 0.395653 14.9627 0 14.412 0H9.71229C9.16159 0 8.69676 0.395653 8.63134 0.9112L8.22575 3.67978C7.69038 3.91559 7.16424 4.21533 6.63193 4.58597L3.96535 3.53891C3.46571 3.35007 2.86802 3.56186 2.61976 4.00748L0.272994 7.97801C-0.0038653 8.43563 0.110547 9.03009 0.538646 9.36181L2.79245 11.0853C2.75668 11.422 2.73934 11.7147 2.73934 11.9895C2.73934 12.2643 2.75673 12.557 2.79245 12.8947L0.536586 14.6192C0.117682 14.9439 0.00427619 15.5184 0.270934 15.996L2.61468 19.9615C2.86501 20.4081 3.40852 20.6399 3.97043 20.4381L6.62988 19.394C7.13867 19.7527 7.67299 20.0564 8.22575 20.3002L8.63034 23.0578C8.69671 23.5833 9.16159 23.9789 9.7133 23.9789H14.413C14.9637 23.9789 15.4296 23.5833 15.495 23.0677L15.9006 20.3002C16.4359 20.0634 16.9611 19.7646 17.4944 19.393L20.1609 20.44C20.2897 20.489 20.4235 20.514 20.5615 20.514C20.9579 20.514 21.3226 20.3022 21.5065 19.9724L23.8604 15.9859C24.122 15.5184 24.0076 14.9439 23.5867 14.6172ZM12.0621 15.9859C9.80832 15.9859 7.97543 14.1935 7.97543 11.9895C7.97543 9.78542 9.80832 7.993 12.0621 7.993C14.3159 7.993 16.1488 9.78542 16.1488 11.9895C16.1488 14.1935 14.3159 15.9859 12.0621 15.9859Z"
                  fill="#7197CC"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <path
                  d="M24.2734 15.5477L24.2734 15.5477L24.2677 15.5433L22.6185 14.279C22.6244 14.1588 22.6279 14.0333 22.6279 13.9044C22.6279 13.7757 22.6245 13.6503 22.6187 13.5297L24.2694 12.2647L24.2736 12.2615C25.0642 11.649 25.2591 10.5705 24.7814 9.71108L24.7752 9.69998L24.7688 9.68904L22.6103 6.02799C22.1363 5.19186 21.1201 4.79594 20.1524 5.14586L20.1392 5.15062L20.1262 5.15574L18.1569 5.93077C17.9343 5.79134 17.7072 5.66165 17.4759 5.54217L17.1806 3.52435C17.0472 2.51581 16.1676 1.81055 15.1904 1.81055H10.8522C9.87854 1.81055 8.99675 2.51234 8.86374 3.51698L8.56731 5.54544C8.33982 5.66375 8.11469 5.79297 7.89091 5.9332L5.91359 5.15485L5.91362 5.15478L5.90161 5.15023C5.00258 4.80961 3.92364 5.16316 3.43851 6.02004L1.27971 9.68164C0.760985 10.547 0.984772 11.6529 1.77073 12.2634L1.77072 12.2635L1.77579 12.2673L3.42504 13.5317C3.41878 13.6589 3.4156 13.783 3.4156 13.9053C3.4156 14.0279 3.41881 14.1522 3.42508 14.2798L1.77402 15.545L1.77401 15.545L1.76871 15.5491C0.978967 16.1628 0.785342 17.241 1.26345 18.0994L1.26941 18.1101L1.27564 18.1207L3.43426 21.782C3.90681 22.6142 4.91616 23.0152 5.89075 22.6643L5.90456 22.6593L5.91822 22.6539L7.88765 21.8788C8.10982 22.0179 8.33661 22.1474 8.56754 22.2669L8.86279 24.2842C8.99592 25.2933 9.87338 26 10.8531 26H15.1913C16.1637 26 17.0475 25.2994 17.1807 24.2936L17.4771 22.2655C17.7045 22.1472 17.9296 22.0179 18.1537 21.8774L20.1308 22.6557L20.1308 22.6558L20.1409 22.6596C20.3716 22.7476 20.6157 22.7936 20.8668 22.7936C21.5777 22.7936 22.2514 22.4174 22.6059 21.7913L24.7736 18.111L24.7796 18.101L24.7852 18.0908C25.2642 17.2324 25.0565 16.157 24.2734 15.5477ZM13.0212 16.6035C11.4743 16.6035 10.2489 15.374 10.2489 13.9053C10.2489 12.4366 11.4743 11.2071 13.0212 11.2071C14.5682 11.2071 15.7936 12.4366 15.7936 13.9053C15.7936 15.374 14.5682 16.6035 13.0212 16.6035Z"
                  fill="#7197CC"
                  stroke="#F0F0F0"
                  stroke-width="2"
                />
              </svg>
            </router-link>

            <h1 class="full-name">
              {{ user.first_name }} {{ user.last_name }}
            </h1>
            <h2 class="username">{{ user.username }}</h2>
            <div class="stat-elem">
              <div class="stat-title">{{ $t("admin.addedNews") }} :</div>
              <div class="stat-res">
                {{
                  user.published_count +
                  user.moderation_count +
                  user.declined_count
                }}
              </div>
            </div>
            <div class="stat-elem">
              <div class="stat-title">{{ $t("admin.views") }} :</div>
              <div class="stat-res">{{ user.view_count }}</div>
            </div>
            <template v-if="user.bio">
              <div class="about-title">{{ $t("staff_page.about_me") }}</div>
              <div class="about-text">
                {{ user.bio }}
              </div>
            </template>
            <router-link
              :to="$staffI18nRoute({ name: 'PreferredLang' })"
              class="add-article"
            >
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34 17C34 26.3967 26.3954 34 17 34C7.60332 34 0 26.3954 0 17C0 16.2665 0.594602 15.6719 1.32812 15.6719C2.06165 15.6719 2.65625 16.2665 2.65625 17C2.65625 24.9284 9.07255 31.3438 17 31.3438C24.9284 31.3438 31.3438 24.9274 31.3438 17C31.3438 9.07162 24.9274 2.65625 17 2.65625C16.2665 2.65625 15.6719 2.06165 15.6719 1.32812C15.6719 0.594602 16.2665 0 17 0C26.3967 0 34 7.60464 34 17ZM10.652 4.10391L12.3698 3.3923C13.0474 3.11153 13.3693 2.33464 13.0885 1.65697C12.8078 0.979293 12.031 0.657289 11.3532 0.938254L9.63535 1.64986C8.95774 1.93063 8.63587 2.70752 8.91663 3.38519C9.19647 4.06061 9.97209 4.38534 10.652 4.10391ZM6.20009 7.51486L7.51486 6.20009C8.03356 5.68139 8.03356 4.84042 7.51486 4.32179C6.99616 3.80315 6.1552 3.80309 5.63656 4.32179L4.32179 5.63656C3.80309 6.15526 3.80309 6.99623 4.32179 7.51486C4.84035 8.03343 5.68139 8.03356 6.20009 7.51486ZM1.65697 13.0886C2.33611 13.3699 3.1122 13.046 3.3923 12.3699L4.10391 10.652C4.38467 9.97429 4.0628 9.1974 3.38519 8.91663C2.70738 8.63593 1.93063 8.95774 1.64986 9.63535L0.938254 11.3532C0.657488 12.031 0.979359 12.8078 1.65697 13.0886ZM17 10.3594C16.2665 10.3594 15.6719 10.954 15.6719 11.6875V15.6719H11.6875C10.954 15.6719 10.3594 16.2665 10.3594 17C10.3594 17.7335 10.954 18.3281 11.6875 18.3281H15.6719V22.3125C15.6719 23.046 16.2665 23.6406 17 23.6406C17.7335 23.6406 18.3281 23.046 18.3281 22.3125V18.3281H22.3125C23.046 18.3281 23.6406 17.7335 23.6406 17C23.6406 16.2665 23.046 15.6719 22.3125 15.6719H18.3281V11.6875C18.3281 10.954 17.7335 10.3594 17 10.3594Z"
                  fill="#57CC55"
                />
              </svg>
              {{ $t("admin.add_news") }}
            </router-link>

            <router-link
              :to="
                $staffI18nRoute({
                  name: 'Articles',
                  params: { status: 'published' },
                })
              "
              class="article-tab-switcher"
            >
              <svg width="4" height="4">
                <circle
                  xmlns="http://www.w3.org/2000/svg"
                  cx="2"
                  cy="2"
                  r="2"
                  fill="#57CC55"
                />
                >
              </svg>
              <div class="label">{{ $t("admin.published_news") }}</div>
              <div class="count">{{ user.published_count }}</div>
            </router-link>
            <router-link
              :to="
                $staffI18nRoute({
                  name: 'Articles',
                  params: {status: 'moderation'}
                })
              "
              class="article-tab-switcher"
            >
              <svg width="4" height="4">
                <circle
                  xmlns="http://www.w3.org/2000/svg"
                  cx="2"
                  cy="2"
                  r="2"
                  fill="#FFC24A"
                />
                >
              </svg>
              <div class="label">{{ $t("admin.moderation") }}</div>
              <div class="count">{{ user.moderation_count }}</div>
            </router-link>
            <router-link
              :to="
                $staffI18nRoute({
                  name: 'Articles',
                  params: {status: 'declined'}
                })
              "
              class="article-tab-switcher"
            >
              <svg width="4" height="4">
                <circle
                  xmlns="http://www.w3.org/2000/svg"
                  cx="2"
                  cy="2"
                  r="2"
                  fill="#FF6969"
                />
                >
              </svg>
              <div class="label">{{ $t("admin.rejected") }}</div>
              <div class="count">{{ user.declined_count }}</div>
            </router-link>
            <router-link
              :to="
                $staffI18nRoute({
                  name: 'Articles',
                  params: { status: 'draft' },
                })
              "
              class="article-tab-switcher"
            >
              <svg width="4" height="4">
                <circle
                  xmlns="http://www.w3.org/2000/svg"
                  cx="2"
                  cy="2"
                  r="2"
                  fill="gray"
                />
                >
              </svg>
              <div class="label">{{ $t("admin.drafts") }}</div>
              <div class="count">{{ user.draft_count }}</div>
            </router-link>
          </div>
          <div class="left-collar-actions">
            <div class="divider"></div>
            <div class="btn btn1" @click="exitAccount">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
              >
                <path
                  d="M17.627 19.3359C17.0876 19.3359 16.6504 19.7731 16.6504 20.3125V23.0469H2.68555V1.95312H16.6504V4.6875C16.6504 5.22686 17.0876 5.66406 17.627 5.66406C18.1663 5.66406 18.6035 5.22686 18.6035 4.6875V0.976562C18.6035 0.437207 18.1663 0 17.627 0H1.70898C1.16963 0 0.732422 0.437207 0.732422 0.976562V24.0234C0.732422 24.5628 1.16963 25 1.70898 25H17.627C18.1663 25 18.6035 24.5628 18.6035 24.0234V20.3125C18.6035 19.7731 18.1663 19.3359 17.627 19.3359Z"
                  fill="#949BA4"
                />
                <path
                  d="M23.9816 11.8095L21.3576 9.18544C20.9763 8.80405 20.358 8.8041 19.9766 9.18544C19.5952 9.56679 19.5952 10.1852 19.9766 10.5665L20.9335 11.5234L12.8437 11.5234C12.3044 11.5234 11.8672 11.9606 11.8672 12.4999C11.8672 13.0393 12.3044 13.4765 12.8437 13.4765L20.9336 13.4766L19.9766 14.4335C19.5952 14.8148 19.5952 15.4332 19.9766 15.8146C20.358 16.196 20.9763 16.1959 21.3577 15.8145L23.9817 13.1905C23.9817 13.1904 23.9818 13.1903 23.9819 13.1903C24.1784 12.9936 24.2606 12.7664 24.2677 12.5C24.2677 12.2367 24.1559 11.9836 23.9816 11.8095Z"
                  fill="#949BA4"
                />
              </svg>
              {{ $t("admin.go_out") }}
            </div>
            <router-link
              class="btn btn2"
              :to="$i18nRoute({ name: 'FeedWrapper' })"
            >
              {{ $t("admin.home") }}
            </router-link>
            <router-link v-if="user.is_journalist" :to="$staffI18nRoute({ name: 'Admin' })" class="admin">
              {{ $t("admin.admin") }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="else-holder">
        <Categories />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useLanguage } from "@/utils/language";
import { computed, watch, ref } from "vue";
import { updateUser } from "@/network/v1";
import Categories from "@/components/staff/Categories";

export default {
  components: {
    Categories,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { i18nRoute } = useLanguage();
    const avatar = ref(null);
    const avatarUrl = ref(null);
    const defaultAvatar =
      "https://avatars.mds.yandex.net/get-kino-vod-films-gallery/28788/47e2fd514411e18b76af786d7417062d/600x380";

    const changeAvatar = () => {
      const file = avatar.value.files[0];
      avatarUrl.value = URL.createObjectURL(file);

      const formData = new FormData();

      formData.append("avatar", file);

      updateUser(
        () => {
          console.log("ok");
        },
        store.getters.access,
        formData,
        () => console.log("errr")
      );
    };

    watch(
      () => store.state.access,
      () => {
        store.dispatch("getMe", {
          cb: () => {
            avatarUrl.value = store.getters.user.avatar;
          },
        });
      },
      { immediate: true }
    );

    const exitAccount = () => {
      store.commit("flushTokens");
      router.push(i18nRoute({ name: "LogIn_Authorization" }));
    };

    return {
      user: computed(() => store.getters.user),
      exitAccount,
      avatar,
      avatarUrl,
      changeAvatar,
      defaultAvatar,
    };
  },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
  --user-highlight-color: #6c8fba;
  --title-color: rgba(123, 123, 123, 1);
  --error-message: rgba(211, 77, 77, 1);

  background-color: var(--user-bg-color);
  position: relative;
  font-family: Roboto, sans-serif;
  min-height: calc(100vh - 100px);

  .wrapper {
    background-image: var(--words-bg-light-url);
    height: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;

    .left-collar-holder {
      position: relative;
      width: 19.375vw;
      margin: 5.208vw 0;
      margin-left: 5.208vw;

      .left-collar {
        height: auto;
        position: relative;
        background-color: var(--user-edit-bg-color);
        display: flex;
        width: 19.375vw;
        align-items: center;
        flex-direction: column;
        color: var(--secondary-font-color);
        z-index: 11;

        .left-collar-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 0.833vw;

          .avatar-holder {
            width: 14.167vw;
            height: 14.167vw;
            cursor: pointer;
            position: relative;
            // transform: translateY(-50%);
            border-radius: 50%;
            margin-top: -8vw;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              border: 0.521vw solid var(--user-edit-bg-color);
            }

            .file-container {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
              background: rgba(0, 0, 0, 0.5);
              transition: all 0.4s ease;
              border-radius: 50%;
              border: 10px solid var(--user-edit-bg-color);

              label {
                font-size: 1.042vw;
                line-height: 1.25vw;
                font-weight: 400;
                width: max-content;
                pointer-events: none;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%);
                color: var(--primary-font-color);
                border-bottom: 1px solid var(--primary-font-color);
              }

              .file {
                width: 100%;
                height: 100%;
                cursor: pointer;
                position: absolute;
                top: 0;
                margin-top: 1.458vw;
                opacity: 0;
                &::after {
                  content: attr(label);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 50%;
                  right: 0;
                  bottom: 0;
                }
              }
            }

            &:hover {
              .file-container {
                opacity: 1;
              }
            }
          }

          .account-settings {
            position: absolute;
            top: 4.167vw;
            right: 0.521vw;
            width: 2.865vw;
            height: 2.865vw;
            border-radius: 50%;
            background: #f0f0f0;
            border: 1px solid rgba(59, 113, 188, 1);
            transition: background-color 0.4s ease;

            svg {
              position: absolute;
              transition: all 0.4s ease;

              &:last-child {
                bottom: 0.569vw;
                left: 0.569vw;
                width: 1.146vw;
                height: 1.146vw;
              }

              &:first-child {
                top: 0.621vw;
                right: 0.417vw;
                width: 1.146vw;
                height: 1.146vw;
              }
            }

            &:hover,
            &.router-link-exact-active {
              background: #f8f8f8;
              width: 2.76vw;
              height: 2.76vw;
              border: 2px solid #3b71bc;

              svg {
                &:last-child {
                  transform: rotate(60deg);
                }

                &:first-child {
                  transform: rotate(-75deg);
                }
              }
            }
          }

          .full-name {
            font-size: 1.458vw;
            line-height: 1.719vw;
            margin-top: 1.302vw;
            margin-top: 1.354vw;
          }

          .username {
            font-size: 1.042vw;
            line-height: 1.25vw;
            margin-top: 0.677vw;
            margin-bottom: 1.3vw;
            font-weight: 300;
            color: var(--user-highlight-color);
          }

          .stat-elem {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-top: 0.729vw;

            .stat-title {
              font-size: 0.938vw;
              font-weight: 300;
            }

            .stat-res {
              font-size: 0.938vw;
              line-height: 1.146vw;
            }
          }

          .about-title {
            font-weight: 500;
            width: 100%;
            font-size: 0.833vw;
            line-height: 1.146vw;
            margin-top: 1.302vw;
            color: var(--user-highlight-color);
          }

          .about-text {
            margin-top: 0.521vw;
            padding: 0.833vw;
            border: 1px solid #9ec1ec;
            background: #f8f8f8;
            line-height: 122%;
            color: #586574;
            width: 18.333vw;
            font-size: 0.833vw;
          }

          .add-article {
            width: 100%;
            min-width: 17.708vw;
            height: 3.125vw;
            background: #f8f8f8;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #4d72a6;
            font-weight: 500;
            margin-top: 1.354vw;
            margin-bottom: 1.354vw;
            font-size: 1.354vw;

            svg {
              width: 2vw;
              height: 2vw;
              margin-right: 1vw;
            }
          }

          .article-tab-switcher {
            width: 100%;
            height: 1.979vw;
            display: flex;
            align-items: center;
            position: relative;
            transition: all 0.4s ease;

            svg {
              padding-left: 0.521vw;
              padding-right: 0.833vw;
            }

            .label {
              flex: 1 0 0;
              color: #586574;
              font-size: 1.042vw;
            }

            .count {
              margin-right: 1.042vw;
              font-weight: 100;
              font-size: 1.042vw;
            }

            &:hover {
              background: rgba(245, 245, 245, 0.7);
            }

            &.router-link-exact-active {
              background: #f5f5f5;

              .label {
                color: #6c8fba;
              }
            }
          }
        }

        .left-collar-actions {
          width: 100%;
          position: relative;
          align-items: center;
          margin-top: 0.729vw;
          display: grid;
          grid-template-areas:
            "divider divider"
            "btn btn2"
            "admin admin";

          .divider {
            grid-area: divider;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background: #6c8fba;
          }

          .btn {
            grid-area: btn;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 3.906vw;
            color: #949ba4;
            font-weight: 500;
            font-size: 1.042vw;
            cursor: pointer;
            flex: 1 0 0;
            transition: all 0.4s ease;

            svg {
              padding-right: 0.625vw;
              transition: all 0.4s ease;
              width: 1.802vw;
              height: 1.802vw;
            }

            &:hover {
              color: #6c8fba;

              svg {
                path {
                  fill: #6c8fba;
                }
              }
            }
          }

          .btn2 {
            grid-area: btn2;
          }

          .admin {
            grid-area: admin;
            width: 100%;
            min-width: 15.625vw;
            height: 3.125vw;
            background: #f8f8f8;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #4d72a6;
            font-weight: 500;
            margin-top: 0.26vw;
            margin-bottom: 1.719vw;
            font-size: 1.354vw;
          }
        }
      }
    }

    .else-holder {
      flex: 1 0 0;
    }
  }
}
@media screen and (max-width: 1366px) {
  .left-collar-holder {
    display: none;
  }
  .main-wrapper {
    padding: 0;
    margin: 0;
    .wrapper {
      padding: 0;
      margin: 0;
      .container {
        width: 100%;
        display: block;
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .left-collar-holder {
    display: none;
  }
  .main-wrapper {
    padding: 0;
    margin: 0;
    .wrapper {
      padding: 0;
      margin: 0;
      .container {
        width: 100%;
        display: block;
      }
    }
  }
}
</style>
